module.exports = __webpack_public_path__ + "img/huntica-rt-menu.95e9ecf5.svg";